/* eslint-disable react/jsx-key */
import React, { useState } from "react"
import { get } from "../../helpers/utils"
import Typography from "../UI/Typography/Typography"
import { REQUIRED_SEARCH, PAGE_VALUE } from "../../constants/label.constants"
import PropTypes from "prop-types"
import * as styles from "./MdlzNewsSearch-tw-styles"
import Pagination from "../Pagination/Pagination"
import variants from "../../constants/variants.constants"
import Link from "../UI/Link/Link"
const MdlzNewsSearch = props => {
  const { title, datesCollection } = props
  const [data, setdata] = useState(get(datesCollection, "items", []))
  const [realdata, setrealdata] = useState(get(datesCollection, "items", []))
  const [currentPage, setCurrentPage] = useState(1)
  const [filterVal, setfilerVal] = useState("")

  const totalpage = Math.ceil(data.length / PAGE_VALUE)

  const [firstindex, setfirstindex] = useState(0)
  const [lastindex, setlastindex] = useState(10)
  const style = styles.defaultStyle
  const {
    InputContainer,
    container,
    dateNews,
    dateContainer,
    inputElement,
    linkPara,
    dateData,
    linkColor,
    headingTitle,
    day,
    newsContainer,
    searchDate,
    searchNews,
    searchContainer,
    containerWrapper,
    Para,
  } = style

  const onchange = pagenumber => {
    setCurrentPage(pagenumber)
    setfirstindex(pagenumber * PAGE_VALUE - PAGE_VALUE)
    setlastindex(pagenumber * PAGE_VALUE)
  }
  const handlechange = e => {
    if (e == "") {
      setdata(realdata)
    } else {
      const filterdata = realdata.filter(a => {
        return (
          a?.title.toLowerCase().includes(e.toLowerCase()) ||
          a?.description.toLowerCase().includes(e.toLowerCase()) ||
          a?.dates?.includes(e.toString())
        )
      })
      setdata(filterdata)
    }
    setfilerVal(e)
  }

  return (
    <div className={newsContainer}>
      {title && <h2 className={headingTitle}>{title}</h2>}
      <div className={containerWrapper}>
        <div className={container}>
          <div className={InputContainer}>
            <input
              type="text"
              placeholder={REQUIRED_SEARCH.Search}
              onInput={e => handlechange(e.target.value)}
              className={inputElement}
              aria-label="Search Input"
              id = "inputChange"
            />
          </div>
          <div>
            <div className={searchContainer}>
              <div className={dateNews}>
                <div className={searchDate} data-testid="Required-Search">
                  {REQUIRED_SEARCH.Date}
                </div>
                <div className={searchNews}>{REQUIRED_SEARCH.News}</div>
              </div>
              <div className={dateContainer}>
                {data.slice(firstindex, lastindex)?.map((a, idx) => {
                  return (
                    <div className={dateData} key={idx}>
                      <div className={day}>{a?.dates}</div>
                      <div className={linkPara}>
                        <Link
                          target="_blank"
                          url={a?.urls?.url}
                          className={linkColor}
                        >
                          {a?.title}
                        </Link>
                        <Typography
                          content={a?.description}
                          className={Para}
                        ></Typography>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Pagination
        currentPage={currentPage}
        onPageChange={onchange}
        totalPages={totalpage}
        variant={variants.NEWS_SEARCH_PAGINATION}
      ></Pagination>
    </div>
  )
}

MdlzNewsSearch.propTypes = {
  datesCollection: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  title: PropTypes.string,
}

export default MdlzNewsSearch
